import { FeedbackType } from '@weave/schema-gen-ts/dist/schemas/sms/reply-assistant/v1/reply_assistant_service.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, Button } from '@frontend/design-system';

type TagsFeedbackEndAdornmentProps = {
  handleFeedbackClick: (feedbackType: 'positive' | 'negative') => void;
};

export const TagsFeedbackEndAdornment = ({ handleFeedbackClick }: TagsFeedbackEndAdornmentProps) => {
  const { t } = useTranslation('inbox');

  return (
    <span css={{ display: 'flex', alignItems: 'center' }}>
      <Text
        color='light'
        size='medium'
        css={{
          marginRight: theme.spacing(0.5),
          whiteSpace: 'nowrap',
        }}
      >
        {t('Is this helpful?')}
      </Text>
      <Button
        iconName='feedback-small'
        variant='secondary'
        size='small'
        css={{
          padding: theme.spacing(0.3),
        }}
        onClick={() => handleFeedbackClick('positive')}
        label={t('Mark tag as helpful')}
        trackingId={`inbox-smart-tag-${FeedbackType.FEEDBACK_TYPE_GOOD}-thumbs-up`}
      />
      <Button
        iconName='feedback-bad-small'
        variant='secondary'
        size='small'
        css={{
          padding: theme.spacing(0.3),
        }}
        onClick={() => handleFeedbackClick('negative')}
        label={t('Mark tag as not helpful')}
        trackingId={`inbox-smart-tag-${FeedbackType.FEEDBACK_TYPE_BAD}-thumbs-down`}
      />
    </span>
  );
};
